import styled from "styled-components";
import { mediaMaxWidth } from "../../utils/mediaQueriesTemplate";

export const CandidateActionsWrapper = styled.div`
  background: #fff;
  color: #333;
  border-radius: 8px;
  padding: 20px;
  height: fit-content;
  box-shadow: 0 0 15px #dcdcdc;
  font-family: Raleway;

  ${mediaMaxWidth.tablet`
    margin-bottom: 200px;
  `}
`;

export const Title = styled.div`
  border-bottom: 1px solid #d2d2d2;
  padding: 0 0 5px 0;
  font-weight: 600;
`;

export const MessageFormWrapper = styled.div`
  height: 110px;
  position: fixed;
  bottom: 15px;
  width: 650px;
  border-top: 10px solid #e4e5e7;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
  background: #fff;
  display: flex;
  flex-direction: row;
  align-items: center;

  ${mediaMaxWidth.tablet`
    width: 95vw;
  `}

  ${mediaMaxWidth.phone`
    height: 80px;
  `}
`;

export const Form = styled.form`
  margin: 0 auto;
  position: relative;
  height: 100%;

  button {
    margin-top: 0;
  }

  ${mediaMaxWidth.phone`
    width: 100%;
  `}
`;

export const ActionsButton = styled.div`
  display: flex;
  text-align: left;
  font-weight: 700;
  width: 160px;
  padding: 30px 15px 15px 0;
  cursor: pointer;
  transition: 0.1s ease-in-out;

  &:hover {
    color: #f2008c;
  }

  svg {
    position: relative;
    top: 3px;
    font-size: 0.9em;
    left: 6px;
  }

  ${mediaMaxWidth.phone`
    width: 140px;
    padding: 7px 5px 5px 0;
    font-size: 0.9em;
  `}

  ${mediaMaxWidth.smallPhone`
    padding: 7px 5px 5px 0;
    font-size: 0.75em;
  `}
`;

export const ActionsList = styled.div`
  position: absolute;
  top: 60px;
  background: #fff;
  width: 300px;
  text-align: left;
  border-radius: 4px;
  box-shadow: 0 0 5px #d6d6d6;
  opacity: 0;
  transition: 0.15s ease-in-out;
  left: -300px;
  padding: 10px;
  pointer-events: none;

  &::after,
  &::before {
    bottom: 100%;
    left: 30px;
    border: solid transparent;
    content: "";
    height: 0;
    width: 0;
    position: absolute;
    pointer-events: none;
  }
  &::after {
    border-color: rgba(136, 183, 213, 0);
    border-bottom-color: #fff;
    border-width: 8px;
    margin-left: 0px;
  }
  &::before {
    border-color: rgba(194, 225, 245, 0);
    border-bottom-color: #eaeaea;
    border-width: 10px;
    margin-left: -2px;
  }

  &.shown {
    left: -10px;
    opacity: 1;
    z-index: 1;
    height: 235px;
    pointer-events: auto;

    ${mediaMaxWidth.phone`
      left: 0;
      height: 225px;
    `}

    ${mediaMaxWidth.smallPhone`
      height: 215px;
    `}
  }

  ${mediaMaxWidth.phone`
    width: 250px;
    bottom: 80px;
    top: 40px;
  `}

  ${mediaMaxWidth.smallPhone`
    width: 220px;
  `}
`;

export const Option = styled.input`
  margin: 2px 0;
  display: none;
`;

export const Label = styled.label`
  display: block;
  font-weight: 500;
  margin: 0px 0;
  padding: 7px 10px;
  cursor: pointer;
  transition: 0.05s ease-in-out;

  &:hover {
    background: #f2008c;
    color: #fff;
    border-radius: 4px;
  }

  ${mediaMaxWidth.phone`
    font-size: 0.9em;
  `}

  ${mediaMaxWidth.smallPhone`
    font-size: 0.8em;
  `}
`;

export const ActionsListReduced = styled.div`
  position: absolute;
  top: 60px;
  background: #fff;
  width: 300px;
  text-align: left;
  border-radius: 4px;
  box-shadow: 0 0 5px #d6d6d6;
  opacity: 0;
  transition: 0.15s ease-in-out;
  left: -300px;
  padding: 10px;
  pointer-events: none;

  &::after,
  &::before {
    bottom: 100%;
    left: 30px;
    border: solid transparent;
    content: "";
    height: 0;
    width: 0;
    position: absolute;
    pointer-events: none;
  }
  &::after {
    border-color: rgba(136, 183, 213, 0);
    border-bottom-color: #fff;
    border-width: 8px;
    margin-left: 0px;
  }
  &::before {
    border-color: rgba(194, 225, 245, 0);
    border-bottom-color: #eaeaea;
    border-width: 10px;
    margin-left: -2px;
  }

  &.shown {
    left: -10px;
    opacity: 1;
    z-index: 1;
    pointer-events: auto;

    ${mediaMaxWidth.phone`
      left: 0;
    `}
  }

  ${mediaMaxWidth.phone`
    width: 250px;
    top: 40px;
  `}

  ${mediaMaxWidth.smallPhone`
    width: 220px;
  `}
`;

export const SelectedAction = styled.div`
  margin: 0;
  border: 1px solid;
  border-radius: 4px;
  text-transform: capitalize;
  font-size: 0.85em;
  font-weight: 700;
  width: -webkit-fit-content;
  width: -moz-fit-content;
  width: fit-content;
  border-radius: 4px;
  padding: 4px 25px;
  position: absolute;
  left: 160px;
  top: 25px;
  min-width: 240px;
  display: ${(props) => (props.active ? null : "none")};

  ${mediaMaxWidth.phone`
    padding: 4px 15px 4px 5px;
    font-size: 0.65em;
    left: 135px;
    min-width: 170px;
    top: 5px;
  `}

  ${mediaMaxWidth.smallPhone`
    font-size: 0.6em;
    left: 105px;
    min-width: 160px;
  `}

  &::before {
    content: "•";
    color: #333;
    font-size: 3.1em;
    position: absolute;
    top: -17px;
    left: 5px;
    height: 5px;

    ${mediaMaxWidth.phone`
      display: none;
    `}
  }
`;

export const RemoveAction = styled.span`
  padding: 0 0 0 10px;
  cursor: pointer;

  &::after {
    content: "✖";
    font-size: 1.37em;
    position: absolute;
    font-weight: 700;
    top: 0px;
    right: 7px;
    transition: 0.1s ease-in-out;

    ${mediaMaxWidth.phone`
      top: 2px;
    `}
  }

  &:hover {
    &::after {
      color: #f2008c;
    }
  }
`;

export const TextArea = styled.textarea`
  border: 2px solid #e7e7e7;
  border-radius: 4px;
  width: 100%;
  min-height: 7em;
  resize: none;
  padding: 10px;
  margin: 10px 0 30px 0;

  &:focus {
    border-color: #f2008c;
    outline: none;
    -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075),
      0 0 8px rgba(233, 102, 163, 0.6);
    box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075),
      0 0 8px rgba(233, 102, 163, 0.6);
  }
`;

export const SendButton = styled.input`
  background: none;
  border: none;
  color: #f2008c;
  font-weight: 700;
  transition: 0.2s ease-in-out;

  &:focus {
    outline: none;
  }

  &:focus,
  &:hover {
    color: #673490;
  }
`;

export const DatePickerWrapper = styled.div`
  .react-datepicker-wrapper {
    display: flex;
    flex: 1;
  }

  .react-datepicker-popper {
    ${mediaMaxWidth.tablet`
      will-change: unset !important;
      transform: unset !important;
      top: 95px !important;
    `}
  }

  .react-datepicker-popper[data-placement^="bottom"] {
    ${mediaMaxWidth.tablet`
       margin-top: 0 !important;
    `}
  }

  .react-datepicker__input-container {
    display: flex;
    flex: 1;

    input {
      display: flex;
      flex: 1;
      border: 2px solid #e7e7e7;
      border-radius: 4px;
      width: 100%;
      resize: none;
      padding: 10px;
      margin: 10px 0 0 0;
      cursor: pointer;

      &:focus {
        border-color: #f2008c;
        outline: none;
        box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075),
          0 0 8px rgba(233, 102, 163, 0.6);
      }
    }
  }

  .react-datepicker__navigation--next--with-time:not(
      .react-datepicker__navigation--next--with-today-button
    ) {
    right: 10px;
  }

  .react-datepicker-popper .react-datepicker__triangle {
    left: 50% !important;
    border-bottom-color: #fff !important;
    top: 1px !important;

    ${mediaMaxWidth.tablet`
      display: none;
    `}
  }

  .react-datepicker-popper .react-datepicker__triangle::before {
    border-bottom-color: #fff !important;
    top: 1px !important;

    ${mediaMaxWidth.tablet`
      display: none;
    `}
  }

  .react-datepicker-popper {
    width: 100%;
    cursor: pointer;

    .react-datepicker {
      display: flex;
      flex: 1;
      flex-direction: column;
      border-radius: 4px;
      border: none;
      box-shadow: 0 0 10px #d2d2d2;
    }

    .react-datepicker__header {
      background-color: #fff;
      border-bottom: 1px solid #d2d2d2;
      margin: 5px 20px 0 20px;
    }

    .react-datepicker__header.react-datepicker__header--time {
      border-radius: 0;
    }

    .react-datepicker-time__header,
    .react-datepicker__current-month {
      color: #333;
    }

    .react-datepicker__day-names .react-datepicker__day-name {
      color: #333;
    }

    .react-datepicker__day {
      border: 1px solid #fff;
      width: 30px;
      height: 30px;

      &:hover {
        border-radius: 50%;
        border: 1px solid #f2008c;
        background-color: #fff;
      }
    }

    .react-datepicker__day--keyboard-selected,
    .react-datepicker__day.react-datepicker__day--selected.react-datepicker__day--today {
      background-color: #673490;
      border: 1px solid #673490;
      border-radius: 50%;
    }

    .react-datepicker__day.react-datepicker__day--selected {
      background-color: #f2008c;
      border: 1px solid #f2008c;
      border-radius: 50%;
    }

    .react-datepicker__time-container {
      width: 100%;
      border-left: none;
    }

    .react-datepicker__time-box {
      width: 100% !important;
    }

    .react-datepicker__time {
      border-radius: 8px;
    }

    .react-datepicker__time-list {
      height: 100px !important;
    }

    .react-datepicker__time-list-item {
      &:hover {
        background-color: #efefef !important;
      }
    }

    .react-datepicker__time-list-item.react-datepicker__time-list-item--selected {
      background-color: #f2008c !important;
    }
  }
`;
